import { type ActionItem } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { type SurveyRow } from 'entities/Surveys/model/SurveyRow'
import { SurveysPath } from 'entities/ExportRouters'

export const duplicate = (item: SurveyRow): ActionItem => {
  return {
    text: 'Duplicate',
    icon: 'copy',
    onAction: () => {
      uiStore.changeRoute({
        path: SurveysPath.create,
        options: {
          state: {
            response: { id: item.id },
            isDuplicate: true,
          },
        },
      })
    },
  }
}
